// chat-view.ts
import { LitElement, html, css } from 'lit'
import { customElement, property } from 'lit/decorators.js'

import './chat/chat-header'
import './chat/chat-messages'
import './chat/chat-input'
import { Message } from '../store'

@customElement('chat-view')
export class ChatView extends LitElement {
    @property({ type: Array }) messages: Message[] = []
    @property({ type: String }) personalityName: string = ''

    static styles = css`
        :host {
            display: grid;
            grid-template-rows: auto 1fr auto;
            height: 100%;
            overflow: hidden;
        }
    `

    render() {
        return html`
            <chat-header personalityName=${this.personalityName}></chat-header>
            <chat-messages .messages=${this.messages}></chat-messages>
            <chat-input @message-submit=${this._handleMessageSubmit}></chat-input>
        `
    }

    private _handleMessageSubmit(e: CustomEvent<{ message: string }>) {
        const newMessage: Message = {
            id: '',
            sender: 'user',
            timestamp: new Date().getTime(),
            text: e.detail.message,
        }
        this.messages = [...this.messages, newMessage]
    }
}
